export const generateEmptyRow = (columns) => {
  const obj = {};

  for (const col of columns) {
    if (col.type === "nested") {
      obj[col.uniqueName] = [generateEmptyRow(col.value)];
    } else {
      if (["dropdown", "dynamicDropdown"].includes(col?.type)) {
        obj[col.uniqueName] = null;
      } else {
        obj[col.uniqueName] = "";
      }
    }
  }

  return obj;
};


export const deleteNestedRowByPath = (row, path) => {
    if (typeof row !== 'object' || path.length === 0) return row;

  const newRow = structuredClone(row); // Use _.cloneDeep(row) if needed
  let current = newRow;

  for (let i = 0; i < path.length - 1; i++) {
    const key = path[i];
    current = current?.[key];

    if (current === undefined || current === null) return row; // Invalid path
  }

  const lastKey = path[path.length - 1];

  if (Array.isArray(current)) {
    current.splice(lastKey, 1);
    } else if (typeof lastKey === 'string' && Array.isArray(current[lastKey])) {
    current[lastKey].splice(0, 1); // Edge case: object with array value
  }

  return newRow;
};

export const getValueAtPath = (obj = {}, path = []) => {
  let current = obj;

  for (const p of path) {
    if (current == null || typeof current !== "object") {
      return undefined; // or return "-" if you want fallback
    }
    current = current[p];
  }

  return current;
};

export const getValueByPathArr = (source, path) => {
  if (!Array.isArray(path)) return undefined;

  let current = source;

  for (const key of path) {
    if (
      current === null ||
      current === undefined ||
            (typeof current !== 'object' && !Array.isArray(current))
    ) {
      return undefined;
    }

    current = current[key];
  }

  return current;
};


export const mergePathWithReference = (fullPath, partialPath) => {
  for (let i = 0; i < fullPath.length; i++) {
    // Only try to match if current fullPath key matches first partialPath key
    if (fullPath[i] === partialPath[0]) {
      let match = true;
      let j = 1;
      let k = i + 1;

      // Match partialPath against fullPath, skipping indices in fullPath
      while (j < partialPath.length - 1 && k < fullPath.length) {
        if (typeof fullPath[k] === "number") {
          k++;
          continue;
        }
        if (fullPath[k] !== partialPath[j]) {
          match = false;
          break;
        }
        j++;
        k++;
      }

      // If matched till second-last key in partialPath
      if (match && j === partialPath.length - 1) {
        // Now find next string key in fullPath to replace
        while (k < fullPath.length) {
          if (typeof fullPath[k] === "string") {
            const newPath = [...fullPath];
            newPath[k] = partialPath[partialPath.length - 1];
            return newPath;
          }
          k++;
        }
      }
    }
  }

  // No match found
  return [...fullPath];
};

export const setValueAtPath = (target, path, value) => {
  if (!target || !Array.isArray(path)) return;

  let current = target;

  for (let i = 0; i < path.length; i++) {
    const key = path[i];

    // Last key → set/override value
    if (i === path.length - 1) {
      if (current) {
        current[key] = value;
      }
      return;
    }

    const nextKey = path[i + 1];
    const isNextArray = typeof nextKey === "number";

    // If current is undefined/null, create it
    if (current[key] == null) {
      current[key] = isNextArray ? [] : {};
    }

    // If wrong type, reset safely instead of crash
    if (isNextArray && !Array.isArray(current[key])) {
      current[key] = [];
    } else if (!isNextArray && typeof current[key] !== "object") {
      current[key] = {};
    }

    // Move down safely
    current = current[key] ?? {};
  }
};

// export const setValueAtPath = (target, path, value) => {
//   let current = target;

//   for (let i = 0; i < path.length; i++) {
//     const key = path[i];

//     // At last key: always set/override the value
//     if (i === path.length - 1) {
//       current[key] = value;
//       return;
//     }

//     const nextKey = path[i + 1];
//     const isNextArray = typeof nextKey === "number";

//     // If current[key] is missing, create it (array or object)
//     if (current[key] === undefined) {
//       current[key] = isNextArray ? [] : {};
//     }

//     // If it's the wrong type, do not overwrite — just exit safely
//     if (
//       (isNextArray && !Array.isArray(current[key])) ||
//       (!isNextArray && typeof current[key] !== "object")
//     ) {
//       return; // don't touch wrong structure
//     }

//     current = current[key];
//   }
// };

const deepEqual = (a, b) => {
  if (a === b) return true;

    if (typeof a !== 'object' || typeof b !== 'object' || a == null || b == null)
    return false;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!keysB.includes(key) || !deepEqual(a[key], b[key])) return false;
  }

  return true;
}

export const allElementsEqual = (...items) => {
  if (items.length <= 1) return true;
  const first = items[0];

    return items.every(item => deepEqual(item, first));
}


export const setNestedValues = (obj, path, refObj, value) => {
    const pathKey = path.split(".")
  pathKey.forEach((pk, ind, arr) => {
        if ((pk !== "all") && (arr[ind + 1] === "all")) {
            refObj[pk] = []
            setNestedValues(obj[pk], path.split(".").slice(1).join("."), refObj[pk], value)
    } else if (Array.isArray(obj)) {
      obj.forEach((k, i) => {
                refObj[i] = {}
                setNestedValues(obj[i], path.split(".").slice(1).join("."), refObj[i], value)
            })
    } else if (arr.length === 1) {
            refObj[pk] = value
    }
  });
}

export const toCamelCase = (str) => {
  return str
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase());
}

export const setFieldsInColumns = (fieldName = "", value, path = "", columns = []) => {

    const pathArr = path.split(".")

  pathArr.forEach((pathElement) => {
    columns.forEach((column) => {
      if (pathElement === column?.uniqueName) {
        if (column?.type == "nested") {
                    setFieldsInColumns(fieldName, value, pathArr?.slice(1)?.join("."), column?.value)
        } else {
                    column[fieldName] = value
        }
      }
        })
    })
}

export const setValueByFullPath = (row = {}, columns = [], refobj = {}, path = [], value, orgRefObj) => {

    const pt = path[0]

  if (typeof pt === "number") {
        refobj[pt] ? null : refobj[pt] = {}
        setValueByFullPath(row[pt], columns, refobj[pt], path.slice(1), value, orgRefObj)
  } else if (pt === "all") {
    row.forEach((r, ri) => {
            setValueByFullPath(r, columns, refobj[ri], path.slice(1), value, orgRefObj)
        })
  } else {
        if (path[1] || (path[1] === 0)) {
      columns?.forEach((column) => {
        if (pt === column?.uniqueName) {
          if (column?.type === "nested") {

            const makeStableRef = () => {
              row[column?.uniqueName].forEach((r, ri) => {
                refobj[column?.uniqueName][ri]
                  ? null
                                    : refobj[column?.uniqueName][ri] = {}
                            })
                        }

                        refobj?.[column?.uniqueName] || (refobj?.[column?.uniqueName]?.length > 0)
              ? null
                            : refobj[column?.uniqueName] = Array.from({ length: row[column?.uniqueName]?.length }, () => ({}))

                        refobj?.[column?.uniqueName]?.length === row?.[column?.uniqueName].length
              ? null
                            : makeStableRef()

                        setValueByFullPath(row[column?.uniqueName], column?.value, refobj[column?.uniqueName], path.slice(1), value, orgRefObj)
          }
        }
            })
    } else {
            refobj[pt] = value
        }
    }
  }

export const makeObjForRow = (columns = [], obj = {}) => {
  columns.forEach((column, colIndex) => {
    if (column.type !== "nested") {
            obj[column?.uniqueName] = null
    } else {
            obj[column?.uniqueName] = {}
            makeObjForRow(column?.value, obj?.[column.uniqueName])
    }
    })
}

export const setValueInSimpleObj = (obj = {}, path = [], value) => {
  let current = obj;

  for (let i = 0; i < path.length; i++) {
    const key = path[i];
    const isLast = i === path.length - 1;
    const nextKey = path[i + 1];
    const isNextIndex = typeof nextKey === "number";

    if (isLast) {
      current[key] = value;
    } else {
      if (!(key in current)) {
        current[key] = isNextIndex ? [] : {};
      }
      current = current[key];
    }
  }

  return obj; // returns updated object (optional)
}

// ================================================ Validation Logic start ===================================================

const runValidation = (value, validation) => {
  if (!validation) return { error: false, msg: "" };

  if (validation.required) {
    const isEmpty =
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === "object" && Object.keys(value).length === 0);

    if (isEmpty) {
      return { error: true, msg: validation.msg || "Required field" };
    }
  }

  return { error: false, msg: "" };
};

const validateRowRecursive = (row, columns) => {
  const errors = {};
  columns.forEach((col) => {
    if (col.type === "nested" && Array.isArray(row[col.uniqueName])) {
            errors[col.uniqueName] = row[col.uniqueName].map((childRow) =>
                validateRowRecursive(childRow, col.value) // col.value = child columns
      );
    } else {
            errors[col.uniqueName] = runValidation(row[col.uniqueName], col.validation);
    }
  });

  return errors;
};

export const validateAllRows = (columns, rows) => {
  return rows.map((row) => validateRowRecursive(row, columns));
};

// ================================================ Validation Logic end ======================================================

// recursively check if any error = true
export const checkHasError = (node) => {
  if (Array.isArray(node)) {
    return node.some((item) => checkHasError(item));
  }
  if (node && typeof node === "object") {
    if ("error" in node && typeof node.error === "boolean") {
      return node.error; // found error flag
    }
    return Object.values(node).some((val) => checkHasError(val));
  }
  return false;
};

export const checkDynamicValidation = (dataArr) => {
  const validateFieldObject = (fieldObj) => {
        if (!fieldObj || typeof fieldObj !== "object") return { error: false, msg: "" };

    const { dynamicType, value } = fieldObj;
    const validation = dynamicType?.validation;

    if (validation) {
      let error = false;
      let msg = "";

      if (validation.required && (!value || value.toString().trim() === "")) {
        error = true;
        msg = validation.msg || `${dynamicType?.name || ""} is required`;
      }

      return { error, msg };
    }

    return { error: false, msg: "" };
  };

  const processRow = (row) => {
    if (!row || typeof row !== "object") return row;

    let newRow = {};

    Object.entries(row).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        newRow[key] = value.map((item) => processRow(item));
      } else if (value && typeof value === "object" && !value.dynamicType) {
        let validatedFieldObj = {};
        Object.entries(value).forEach(([fieldKey, fieldValue]) => {
          validatedFieldObj[fieldKey] = validateFieldObject(fieldValue);
        });
        newRow[key] = validatedFieldObj;
      } else {
        newRow[key] = validateFieldObject(value);
      }
    });

    return newRow;
  };

  return dataArr.map(processRow);
};


export const checkHasErrorInDynamic = (dataArr) => {
  const checkError = (item) => {
    if (Array.isArray(item)) {
      return item.some(checkError); // check inside arrays
    }
    if (item && typeof item === "object") {
      if ("error" in item) {
        return item.error === true; // direct error object
      }
      return Object.values(item).some(checkError); // check nested objects
    }
    return false;
  };

  return dataArr.some(checkError);
};



